import dayjs from "dayjs";

export interface MemberInfo {
  articleVip?: boolean;
  articleExpiredAt?: string | number | Date | dayjs.Dayjs;
}

export const formatMember = (user: MemberInfo) => {
  const _user = user;
  return _user
    ? {
        ..._user,
        articleExpiredAt: _user.articleExpiredAt
          ? dayjs(_user.articleExpiredAt).format("YYYY-MM-DD")
          : "",
      }
    : {};
};
